// @flow
import * as React from 'react';
import UnauthLoginPage from 'app/common/react/components/growth/unauth/UnauthLoginPage/UnauthLoginPage';
import withRouteData from 'app/common/lib/react/withRouteData';
import { compose } from 'redux';

type Props = {
  route?: {
    legacy_server_context: *,
  },
  location?: {
    query: {
      board_invite?: string,
      next?: string,
      auto_follow?: *,
      prev?: string,
      amp_client_id?: string,
    },
  },
  params: {
    next?: string,
    prev?: string,
    auto_follow?: string,
    amp_client_id?: string,
  },
};

const Login = ({ location, route, params }: Props) => {
  if (!route || !location) {
    // Not pure react
    return (
      <UnauthLoginPage
        options={{
          next: params.next,
          prev: params.prev,
          auto_follow: params.auto_follow,
          amp_client_id: params.amp_client_id,
        }}
      />
    );
  }

  return (
    <UnauthLoginPage
      context={route.legacy_server_context}
      options={{
        board_invite: location.query.board_invite === 'true',
        next: location.query.next,
        auto_follow: location.query.auto_follow,
        prev: location.query.prev,
        amp_client_id: location.query.amp_client_id,
      }}
    />
  );
};

export default compose(
  // $FlowFixMe: new errors found from flow 0.96 upgrade
  withRouteData({
    name: 'UnauthLoginReactWrapper',
    routeContextLog: () => ({
      view_type: PCONST.thrift.ViewType.LOGIN,
    }),
  }),
)(Login);
